module.exports = __webpack_public_path__ + "static/media/instagram.ab1eb56e.png";